//---------------------------------------------------
//  Nom du fichier : Publication.js 
//
//  Description: Component qui affiche une publication
//               Contient les commentaires, (publication,like,report,delete)
//               Permet de basculer sur modification si c'est notre publication
//               Contient la logique de (like,save,achieve) de publication
//               Permet de signaler une publication
//               Permet d'aller sur le profil
//               Permet de voir la température
//               Permet de chercher l'itinéraire vers l'endroit de publication
//               Permet de copier un lien vers la publication pour la partager
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import './Publication.css';
import { useState, useEffect } from "react";
import { path_dict, sections, translate_grade } from './grades';
import Background from './background';
import Signalement from './Signalement';
import {callAPI} from './callAPI.js'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from '@mui/material/Button';

function Comments({isOpen, postId, isLoggedIn, set_publication}){

  const { t } = useTranslation();
  const [text, setText] = useState("")
  const [comments, setComments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [signaling, setSignaling] = useState(false)
  const [warning, setWarning] = useState(false)
  const [currentId, setCurrentId] = useState(0)
  const navigate = useNavigate();
  const create_comment = (e) => {
    e.preventDefault();

    if(text == "") return

    const form = new FormData()
    form.append('type', 'create_comment')
    form.append('post_id', postId)
    form.append('content', text)

    callAPI("write", form)
    .then((data) => {
      render_comments()
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });

    setText("");
  }

  const like_comment = (id, ILiked) => {

    if(isLoading) return
    setIsLoading(true)
    const form = new FormData()
    form.append('type', 'like_comment')
    form.append('comment_id', id)
    form.append('value', !ILiked)

    callAPI("write", form)
    .then((data) => {
      render_comments()
      setIsLoading(false)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }


  const delete_comment = () => {

    const form = new FormData()
    form.append('type', 'delete_comment')
    form.append('comment_id', currentId)

    callAPI("write", form)
    .then((data) => {
      render_comments()
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }

  const render_comments = () => {
    const form = new FormData()
    form.append('type', 'getPostComments')
    form.append('post_id', postId)

    callAPI("read", form)
    .then((data) => {
      setComments(data.result)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }

  useEffect(() => {
    render_comments()
  }, [])


  const write = {
    width: isOpen ? `80%` : `0%`
  }

    return (<>
        {comments.length > 0 ? (
            comments.map(comment => (
              <div className={'singleComment' + (comment.user_id == localStorage.getItem("user_id") ? ' own' : '')} key={comment.id}>
                <div className='commentUser'>
                  <div className='profilePictureComs' style={{
                  backgroundImage: comment.user_picture 
                    ? `url('https://rockstoclimb.com/uploads/profiles/${comment.user_picture}')` 
                    : "url('/Images/defImage.png')"
                  }} onClick={() => {
                    set_publication(null)
                    navigate(`/profil/${comment.user_id}`)
                  }}></div>
                  <div onClick={() => {
                  set_publication(null)
                  navigate(`/profil/${comment.user_id}`)
                }} className='userButton' id='userButtonComm'>
                  {comment.username}
                </div>
                </div>
                <div className='commentText'>{comment.content}</div>
                <div className='commentUtils'>
                  <div className='likesSectionCom'>
                    {isLoggedIn && (
                      <span
                        onClick={() => {like_comment(comment.id, comment.ILiked)}}
                        id='likeComment'
                        className="like material-symbols-outlined"
                        style={{
                          fontVariationSettings: `'FILL' ${comment.ILiked ? 1 : 0}, 'wght' 300, 'GRAD' 200, 'opsz' 24`,
                          color:  `${comment.ILiked ? "var(--secondaryLight)" : "var(--secondary)"}`,
                          transition: "font-variation-settings 0.2s ease, color 0.2s ease"
                        }}
                      >
                        favorite
                      </span>
                    )}
                    {!isLoggedIn && <span id='likeComment' style={{
                      fontVariationSettings: `'FILL' 1, 'wght' 300, 'GRAD' 200, 'opsz' 24`,
                      cursor: 'default'
                    }} className='like material-symbols-outlined'>favorite</span>}
                    <div className='nbLikeComment'>{comment.nbLike}</div>
                  </div>
                  {isLoggedIn && (
                    comment.user_id != localStorage.getItem("user_id") && (
                      <span
                        onClick={() => {
                          setSignaling(!signaling);
                          setCurrentId(comment.id);
                        }}
                        className='material-symbols-outlined report'
                        id='reportPublication'
                      >
                        flag_2
                      </span>
                    )
                  )}
                  {isLoggedIn && comment.user_id == localStorage.getItem("user_id") && (
                    <span
                      className="material-symbols-outlined report"
                      id='delete'
                      onClick={() => {
                        setWarning(!warning);
                        setCurrentId(comment.id);
                      }}
                    >
                      delete
                    </span>
                  )}
                </div>
              </div>
            ))
        ): (
            <p className='noComs' style={{color:'var(--secondary)'}}>{t('publication_comment')}</p>
        )}
        {isLoggedIn &&       
        <div className='commentWriting singleComment'>
        <form onSubmit={create_comment} className='commentForm' style={write}>
          <textarea className='commentBody'
                value={text}
                onChange={(e) => {setText(e.target.value)}}></textarea>
          <button type="submit" className='commentButton'>
            <span id="commentIconSpan" className='material-symbols-outlined' style={{fontSize: isOpen ? `1.8vw` : `0vw`, width: "100%"}}>
              send
            </span>
          </button>
        </form>
        {signaling && <Signalement from="comment" open_signalement={setSignaling} id={postId} comment_id={currentId}/>}
        {warning && <Warning setWarning={setWarning} delete_func={delete_comment}/>}
      </div>}
    </>)
}



function OtherUtils({setWarning, setCreating, setPublication, info, setShowUtils}){
  const { t } = useTranslation();
  const back = {
    top: '0'
  } 
  return(
    <Background func={() => {setShowUtils(null)}} style={back}>
      <div className='otherUtils' id='otherUtilsOwn'>
        <div className='divModEtSupOtherUtils'>
          <span className="material-symbols-outlined otherUtilisMod" onClick={() => {setCreating(info); setPublication(null)}}>edit</span>
          <span className="material-symbols-outlined otherUtilisMod" onClick={() => {setWarning(true); setShowUtils(false)}}>delete</span>
        </div>
        <Button variant="outlined" id="cancelModify" className='otherUtilisCancel btBase' onClick={() => {setShowUtils(false)}}>
            {t('cancel')}
        </Button>
      </div>
    </Background>
  )
}


function Warning({setWarning, delete_func}){
  const { t } = useTranslation();
  const back = {
    top: '0'
  } 

  return(
    <Background func={() => {setWarning(null)}} style={back}>
      <div className='otherUtils'>
        <span
          className="material-symbols-outlined otherUtilisSup"
          id="otherUtilisSupComs"
          onClick={() => { delete_func(); setWarning(false); }}
        >
          delete_forever
        </span>
        <Button variant="outlined" className='otherUtilisCancel btBase'   onClick={() => {setWarning(false)}}>
            {t('cancel')}
        </Button>
      </div>
    </Background>
  )
}



function Publication({post_id, set_publication, grade_type, setDestination, render_markers, setCreatingPublication, setLogin, fromAcceuil}) {

  const [imageUrl, setImageUrl] = useState(null)
  const [title, setTtitle] = useState("")
  const [description, setDescription] = useState(null)
  const [grade, setGrade] = useState(null)
  const [user, setUser] = useState(null)
  const [userPicture, setUserPicutre] = useState(null)
  const [isMyPost, setIsMyPost] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isSaved, setIsSaved] = useState(false)
  const [isAchieved, setIsAchieved] = useState(false)
  const [isLiked, setIsLiked] = useState(false)
  const [nbLikes, setNbLikes] = useState(false)
  const [nbReussite, setNbReussite] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [openComments, setOpenComments] = useState(false)
  const [signaling, setSignaling] = useState(false)
  const [postUserId, setPostUserId] = useState(null)
  const [showUtils, setShowUtils] = useState(false)
  const [warning, setWarning] = useState(false)
  const [pos, setPos] = useState([])
  const [temp, setTemp] = useState(null)

  const { t } = useTranslation();

  const navigate = useNavigate();

  const post_interaction = (interaction, value, setValue) => {

    if(isLoading) return
    setIsLoading(true)

    if(interaction == 'like'){
      setNbLikes(value ? nbLikes - 1 : nbLikes + 1)
    }
    if(interaction == 'achieve'){
      setNbReussite(value ? nbReussite - 1 : nbReussite + 1)
    }
    const form = new FormData()
    form.append('type', 'post_interaction')
    form.append('interaction_type', interaction)
    form.append('post_id', post_id)
    form.append('value', !value)

    callAPI("write", form)
    .then((data) => {
      setValue(!value)
      setIsLoading(false)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }

  useEffect(() => {
    const form = new FormData()
    form.append('type', 'getPost')
    form.append('post_id', post_id)

    callAPI("read", form)
    .then((data) => {
      let path = "uploads/publications/" + data.result.file_path
      setImageUrl(path)
      setTtitle(data.result.title)
      setDescription(data.result.description)
      setGrade(data.result.grade)
      setUser(data.result.username)
      setIsLoggedIn(data.user_id != -1)
      setPostUserId(data.result.user_id)
      setUserPicutre( (data.result.user_picture != null ? ("url('https://rockstoclimb.com/uploads/profiles/" + data.result.user_picture + "')") : 'url("/Images/defImage.png")' ) )

      setIsSaved(data.result.isSaved)
      setIsAchieved(data.result.isAchieved)
      setIsLiked(data.result.isLiked)
      setNbLikes(data.result.nbLike)
      setNbReussite(data.result.nbReussite)
      setPos([data.result.lat, data.result.lng])

      if(data.result.title != null){
          //https://open-meteo.com/ 500 requetes par jour
          fetch("https://api.open-meteo.com/v1/forecast?latitude="+ data.result.lat +"&longitude="+ data.result.lng +"&current_weather=true", {
            method: "GET",
          }) 
          .then(response => response.json())
          .then(data => {
            setTemp(data.current_weather.temperature + '°C')
          })
          .catch(error => console.error("Error fetching session:", error));
      }

      if(data.result.user_id == data.user_id) setIsMyPost(true)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });

  }, []);


  function delete_post(){

    const form = new FormData()
    form.append('type', 'delete_post')
    form.append('post_id', post_id)

    callAPI("write", form)
    .then((data) => {
      setWarning(false) 
      setShowUtils(false)
      set_publication(null)
      render_markers()
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }

  const imageDotButton = {
    color: showUtils || signaling ? `var(--secondaryLight)` : null 
  }

  const [gradeColor, setGradeColor] = useState("#d5b263")

  function grade_color(){
    sections.forEach((section, index) => {
      if(section.includes(grade)){
        setGradeColor(path_dict[index])
      }
    });
  }

  const formatValue = (value) => {
    if (value >= 1000000) {
        return (value / 1000000).toFixed(1) + 'M'; // Formate en "1.2M" par exemple
    }
    if (value >= 1000) {
        return (value / 1000).toFixed(1) + 'k'; // Formate en "1.2k"
    }
    return value; // Retourne le nombre tel quel si inférieur à 1000
  };
  
  useEffect(() => {
    grade_color();
  }, [grade]);

  return (
    <Background func={() => {set_publication(null)}}>
        <div className='publication'>
          {title == null ? <div className='PublicationDeleted'>{t('publication_delete')}</div> :
          <>
          <div className='imageAndGrade'>
            <img src={ imageUrl && 'https://rockstoclimb.com/' + imageUrl} className='publication_image'></img>
            { isLoggedIn &&
                <div onClick={() => {
                  setDestination(null)
                  setTimeout(() => {
                    setDestination(pos)
                  },1)
                  set_publication(null)
                  navigate("/")
                  }} className='trajet'><span className="material-symbols-outlined trajetImage">pin_drop</span>  
                </div>
            }
            <div className='temperaturePublication'>
              {temp} 
            </div>
          </div>
          <div className='informationSurLaPublication'>
            <div className='headerInformation' style={{ backgroundColor: `var(--grade${gradeColor})` }}>
              <div className='titlePublication' title={title}>
                { title }
              </div>
              <div className="gradePublicationView">
              {translate_grade(grade_type, grade)}</div>
            </div>
            <div className='bodyInformation'>
              <div className='topTop'>
                <div className='topOfTheInformationBody'>
                  <div className='pictureAndUser'>
                    <div style={{backgroundImage:userPicture}} className='ProfilePicturePublication' onClick={() => {
                      set_publication(null)
                      navigate(`/profil/${postUserId}`);
                    }}></div>
                    <button className='userButton' onClick={() => {
                      set_publication(null)
                      navigate(`/profil/${postUserId}`);
                    }}>
                      { user }
                    </button>
                  </div>
                  <div className='buttonTopOfTheInformationBody'>
                    <span
                      className="material-symbols-outlined share"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        navigator.clipboard.writeText("https://rockstoclimb.com/" + post_id + "_" + pos[0] + "_" + pos[1]);
                        let pop = document.createElement("div");
                        pop.classList.add("pop_up_copied");
                        pop.style.left = e.clientX + 'px';
                        pop.style.top = e.clientY + 'px';
                        pop.textContent = "copied!";
                        document.body.append(pop);
                        setTimeout(() => {
                          pop.remove();
                        }, 1500);
                      }}
                    >
                      share
                    </span>
                    {isMyPost && (
                      <span
                        className="material-symbols-outlined modif"
                        style={{ ...imageDotButton}}
                        onClick={() => setShowUtils(!showUtils)}
                      >
                        more_horiz
                      </span>
                    )}
                    {isLoggedIn && !isMyPost && (
                      <span className="material-symbols-outlined report" onClick={() => setSignaling(!signaling)}>
                        flag_2
                      </span>
                    )}
                    <span className="material-symbols-outlined closePublicationBtn" onClick={() => set_publication(null)}>
                      close
                    </span>
                  </div>
                </div>
                <div className='commentAndDesc'>
                  <div className='descriptionPub'>
                    { description }
                  </div>
                  <Comments 
                    isOpen={openComments} 
                    postId={post_id} 
                    isLoggedIn={isLoggedIn}
                    set_publication={set_publication}
                  ></Comments> 
                </div> 
            </div>
              {signaling && <Signalement from="publication" open_signalement={setSignaling} id={post_id}/>}
              <div className='sectionBas'>
                <div className='sectionBtnBas'>
                  <div className='appreciation'>
                    {isLoggedIn && (
                      <Button variant='outlined' 
                              className='container_btn_post btBase' 
                              onClick={() => {post_interaction("like", isLiked, setIsLiked)}}
                              id={(nbLikes > 999 ? "percent_25" : 'percent_20')}>
                      <span
                        className="like material-symbols-outlined"
                        style={{
                          fontVariationSettings: `'FILL' ${isLiked ? 1 : 0}, 'wght' 300, 'GRAD' 200, 'opsz' 24`,
                          color:  `${isLiked ? "var(--secondaryLight)" : "var(--secondary)"}`,
                          transition: "font-variation-settings 0.2s ease, color 0.3s ease"
                        }}
                      >
                        favorite
                      </span>
                      <div className='text_in_icon'>{formatValue(nbLikes)}</div>
                      </Button>
                    )}
                    {isLoggedIn && (
                      <Button variant='outlined' 
                              className='container_btn_post btBase' 
                              onClick={() => post_interaction("achieve", isAchieved, setIsAchieved)}
                              id={(nbReussite > 999 ? "percent_25" : 'percent_20')}>
                        <span
                          className="like material-symbols-outlined"
                          style={{
                            fontVariationSettings: `'FILL' ${isAchieved ? 1 : 0}, 'wght' 300, 'GRAD' 200, 'opsz' 24`,
                            color:  `${isAchieved ? "var(--secondaryLight)" : "var(--secondary)"}`,
                            transition: "font-variation-settings 0.2s ease, color 0.3s ease"
                          }}>
                      
                          verified
                        </span>
                        <div className='text_in_icon'>{formatValue(nbReussite)}</div>
                      </Button>
                      
                    )}
                    {isLoggedIn && (
                      <span
                        onClick={() => post_interaction("save", isSaved, setIsSaved)} // Utilisation de isSaved ici
                        className="like material-symbols-outlined"
                        style={{
                          fontVariationSettings: `'FILL' ${isSaved ? 1 : 0}, 'wght' 300, 'GRAD' 200, 'opsz' 24`, // Transition entre les états de "sauvegardé" et non
                          color:  `${isSaved ? "var(--secondaryLight)" : "var(--secondary)"}`,
                          transition: "font-variation-settings 0.2s ease, color 0.3s ease"
                        }}
                      >
                        bookmark
                      </span>
                    )}
                  </div>
                  {isLoggedIn && (
                    <span
                      onClick={() => setOpenComments(!openComments)}
                      className="like material-symbols-outlined"
                      id='commentIconBtn'
                      style={{
                        fontVariationSettings: `'FILL' ${openComments ? 1 : 0}, 'wght' 300, 'GRAD' 200, 'opsz' 24`,
                        transition: "font-variation-settings 0.5s ease, color 0.6s ease"
                      }}
                    >
                      comment
                    </span>
                  )}
                  {!isLoggedIn && <button onClick={() => {if(fromAcceuil){setLogin(true); set_publication(false)} else{set_publication(false); navigate("/login")}}} className='nonConnectedIndication'>{t('publication_not_connected')}</button>}
                </div>
              </div>
              {showUtils && <OtherUtils setShowUtils={setShowUtils} setWarning={setWarning} setCreating={setCreatingPublication} setPublication={set_publication} info={{"title" : title, "description" : description, "grade":grade, "pos": pos, "image": imageUrl, "post_id":post_id}}/>}
              {warning && <Warning setWarning={setWarning} delete_func={delete_post}/>}
              </div>
            </div>
          </>
          }
          
        </div>
      </Background>
  );
}

export default Publication;
